<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <v-tab :to="{ name: 'terms-and-conditions' }" ripple>Terms & Conditions</v-tab>
      <v-tab :to="{ name: 'agree-terms-and-conditions' }" ripple>ข้อมูลผู้ยินยอม</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentView: 'terms-and-conditions'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/TermsAndConditions/MainMenu.vue